import { render, staticRenderFns } from "./rate-section-item.vue?vue&type=template&id=3130d34d"
import script from "./rate-section-item.vue?vue&type=script&lang=js"
export * from "./rate-section-item.vue?vue&type=script&lang=js"
import style0 from "./rate-section-item.vue?vue&type=style&index=0&id=3130d34d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports